<template>
  <div class="relative flex flex-col w-full rounded lg:inline-block">
    <!-- Button to activate dropdown -->
    <button
    @click="pressDropdown()"
      class="flex flex-row items-center justify-between w-full px-4 py-2 rounded lg:text-white focus:outline-none group"
    >
      <span :class="[prependVariant('group-hover', selectedStyle), 'px-2', activeStyle]">{{subCategory}} </span>
      <font-awesome-icon v-if="items.length != 0" :icon="desktopMenuChevron" :class="['fa-xs lg:block hidden', activeStyle]"/>
      <font-awesome-icon v-if="items.length != 0" :icon="sandwitchMenuChevron" :class="['fa-xs lg:hidden block', activeStyle]"/>
    </button>

    <!-- dropdown list -->
    <ul :style="(right ? 'left:100%;' : 'right:100%;') + ' top:0;'" :class="['lg:absolute text-white',showDropdown ? 'block':'hidden']">
      <li v-for="(dropdownItem, index) in items" v-bind:key="index+'dropdown-item-key'"
        :class="['bg-gray-100 py-2 px-4 block whitespace-no-wrap', {'rounded-t': (index == 0), 'rounded-b': (index == items.length-1)}]"
      >
        <a :class="['px-2 lg:ml-0 ml-6', unselectedStyle, prependVariant('hover', selectedStyle)]" :href="itemURL(dropdownItem.name)">{{dropdownItem.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { busEvents, bus } from '../eventBus';

export default {
  data() {
    return {
      showDropdown: false,
      dropdownHover: false,
      selectedStyle: 'text-black',
      unselectedStyle: 'text-gray-700',
    };
  },
  props: {
    category: {
      type: String,
      required: true,
    },
    subCategory: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    right: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sandwitchMenuChevron() {
      return this.showDropdown ? 'chevron-down' : 'chevron-right';
    },
    desktopMenuChevron() {
      return 'chevron-right';
    },
    activeStyle() {
      return this.showDropdown || this.subDropdownhover ? this.selectedStyle : this.unselectedStyle;
    },
  },
  methods: {
    prependVariant(variant, elemClass) {
      const elemClassTrimmed = ` ${elemClass.trim()}`;
      return elemClassTrimmed.split(' ').join(` ${variant}:`);
    },
    pressDropdown() {
      // No children mean this links to a product page

      if (this.items.length == 0) {
        this.$router.push(
          {
            name: 'Items',
            query: {
              category: this.category,
              subCategory: this.subCategory,
            },
          },
        );
      }
    },
  },
  mounted() {
    bus.$on(busEvents.CLOSE_ALL_OTHER_SUB_DROPDOWNS, (subDropdownName) => {
      if (this.subCategory != subDropdownName) {
        this.showDropdown = false;
      }
    });

    this.$el.addEventListener('click', (event) => {
      bus.$emit(busEvents.CLOSE_ALL_OTHER_SUB_DROPDOWNS, '');
      bus.$emit(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, '');

      event.stopPropagation();
    });
  },
};
</script>

<style scoped>

</style>
